import { Grid, Skeleton } from "@mui/material";
import React from "react";

function CarouselSkeleton() {
  return (
    <Grid container spacing={2} alignItems={"center"}>
      {[1, 2, 3, 4].map((item, i) => {
        return (
          <Grid item xs={12} sm={12} md={3} lg={3} key={i}>
            <Skeleton variant="rectangular" width="100%" height={250} />
          </Grid>
        );
      })}
    </Grid>
  );
}

export default CarouselSkeleton;
